/* istanbul ignore file - need to fix flakey tests */
import { getPartCategoryTree, type CategoryNode } from '@services/productInventory';
import { useQuery } from '@tanstack/react-query';
import { useFlatTree } from './useFlatTree';

// Extended CategoryNode with parent reference
export interface CategoryNodeWithParent extends Omit<CategoryNode, 'children'> {
  parent?: string;
}

export function usePartsCategoriesData({
  accountId,
  configurationPID,
  productPID,
}: {
  accountId: string;
  configurationPID: string;
  productPID: string;
}) {
  const { data, ...rest } = useQuery(['getPartCategoryTree', configurationPID, productPID], () =>
    getPartCategoryTree({ accountId, configurationPID, productPID })
  );

  const flatTree = useFlatTree<CategoryNode>(data?.categories);

  return { data: flatTree, ...rest };
}
